/*** @jsx React.DOM */

// Dependencies
var Reflux = require('reflux');

// Actions
var JobActions = require('../actions/job_actions');

module.exports = Reflux.createStore({
        
	// Listen on actions
    listenables: [JobActions],
    
    onToggleApplyPopup : function(params){
    	    	
	    this.trigger('toggle_apply_popup', params);
    }
});